export default __webpack_public_path__ + "static/media/Vanh.b20d230f.jpeg";